import { IProperty } from "src/components/Properties/types";
import bag from "src/assets/icons/bag.svg";
import cash from "src/assets/icons/cash.svg";
import savings from "src/assets/icons/savings.svg";
import { IInquiry } from "src/@types/inquiries";

const CURRENCY = "$";

export const getPropertiesInquiry = (inquiry: IInquiry): IProperty[] => [
  {
    label: "Min. Inv.",
    value: `${CURRENCY} ${
      inquiry.investment_for_start?.toLocaleString() || "??" // for case if value null or undefined
    }`,
    icon: {
      url: savings,
      title: "",
    },
  },
  {
    label: "List Price",
    value: `${CURRENCY} ${inquiry.inquiry_cost?.toLocaleString() || "??"}`,
    icon: {
      url: cash,
      title: "",
    },
  },
  {
    label: "Industry",
    value: `${inquiry.industry.title}`,
    icon: {
      url: bag,
      title: "",
    },
  },
  {
    label: "Business Type",
    value: `${inquiry.inquiry_type.title}`,
    icon: {
      url: bag,
      title: "",
    },
  },
  {
    label: "Employees",
    value: inquiry.employees,
    icon: {
      url: bag,
      title: "",
    },
  },
  {
    label: "Years on the market",
    value: inquiry.years_on_market,
    icon: {
      url: bag,
      title: "",
    },
  },
  {
    label: "№ of customers",
    value: inquiry.customers_count,
    icon: {
      url: bag,
      title: "",
    },
  },
  {
    label: "Annual Turnover",
    value: `${CURRENCY} ${
      inquiry.inquiry_turnover_min?.toLocaleString() || "??"
    } - ${CURRENCY} ${inquiry.inquiry_turnover_max?.toLocaleString() || "??"}`,
    icon: {
      url: bag,
      title: "",
    },
  },
  {
    label: "Monthly Income",
    value: `${CURRENCY} ${
      inquiry.monthly_income_min?.toLocaleString() || "??"
    } - ${CURRENCY} ${inquiry.monthly_income_max?.toLocaleString() || "??"}`,
    icon: {
      url: bag,
      title: "",
    },
  },
];
